/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LicencedModuleXatenaModules = 'Rfx' | 'RfxPro' | 'Request' | 'CartAnalytics' | 'Recall' | 'Catalog' | 'CatalogSup' | 'RfxSpecs' | 'SupplierMgmt' | 'Contract' | 'Reporting' | 'Analytics' | 'CritMgrZK' | 'CritMgrEK' | 'BidMgr' | 'Collab' | 'ShowRoom' | 'ContractSup' | 'SupplyIncident' | 'SecondMarket' | 'MasterData' | 'Gpo' | 'Srm' | 'Forecast' | 'MiniTender';

export const LicencedModuleXatenaModules = {
    Rfx: 'Rfx' as LicencedModuleXatenaModules,
    RfxPro: 'RfxPro' as LicencedModuleXatenaModules,
    Request: 'Request' as LicencedModuleXatenaModules,
    CartAnalytics: 'CartAnalytics' as LicencedModuleXatenaModules,
    Recall: 'Recall' as LicencedModuleXatenaModules,
    Catalog: 'Catalog' as LicencedModuleXatenaModules,
    CatalogSup: 'CatalogSup' as LicencedModuleXatenaModules,
    RfxSpecs: 'RfxSpecs' as LicencedModuleXatenaModules,
    SupplierMgmt: 'SupplierMgmt' as LicencedModuleXatenaModules,
    Contract: 'Contract' as LicencedModuleXatenaModules,
    Reporting: 'Reporting' as LicencedModuleXatenaModules,
    Analytics: 'Analytics' as LicencedModuleXatenaModules,
    CritMgrZk: 'CritMgrZK' as LicencedModuleXatenaModules,
    CritMgrEk: 'CritMgrEK' as LicencedModuleXatenaModules,
    BidMgr: 'BidMgr' as LicencedModuleXatenaModules,
    Collab: 'Collab' as LicencedModuleXatenaModules,
    ShowRoom: 'ShowRoom' as LicencedModuleXatenaModules,
    ContractSup: 'ContractSup' as LicencedModuleXatenaModules,
    SupplyIncident: 'SupplyIncident' as LicencedModuleXatenaModules,
    SecondMarket: 'SecondMarket' as LicencedModuleXatenaModules,
    MasterData: 'MasterData' as LicencedModuleXatenaModules,
    Gpo: 'Gpo' as LicencedModuleXatenaModules,
    Srm: 'Srm' as LicencedModuleXatenaModules,
    Forecast: 'Forecast' as LicencedModuleXatenaModules,
    MiniTender: 'MiniTender' as LicencedModuleXatenaModules
};

